import api from "./api-client";
import { useQuery } from "@tanstack/react-query";
import { LandingPageContentType } from "@/types/landing-page";
import i18n from "@/i18n";

export const landingPageKeys = {
  all: (locale: string) => ["landing-page-content", locale] as const,
};

const getLandingPageContent = async (): Promise<LandingPageContentType> => {
  const res = await api.get<LandingPageContentType>("/landing-page", {
    params: {
      lang: i18n.language,
    },
  });
  return res.data;
};

export const useGetLandingPageContent = (locale: string) => {
  return useQuery({
    queryKey: landingPageKeys.all(locale),
    queryFn: getLandingPageContent,
  });
};
